"use client";

import { useEffect, useState } from "react";
import { Divider, Spin } from "antd";
import { CenterSpinnerAtom } from "~/components/Atoms/CenterSpinnerAtom/CenterSpinnerAtom";
import LogoAtom from "~/components/Atoms/LogoAtom/LogoAtom";
import { LogInButton } from "~/components/Components/LogInButton/LogInButton";
import { useAuth } from "~/hooks/useAuth";
import { useIsEthBrowser } from "~/hooks/useIsEthBrowser";
import { SettingCopyrightModule } from "~/components/Modules/Setting/SettingCopyrightModule";

export default function App() {
  const [isLoading, setIsLoading] = useState(true);
  const { web3authLogin, web3modalLogin } = useAuth();
  const isEthBrowser = useIsEthBrowser();

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  const LoginButtonProps: React.ComponentProps<typeof LogInButton>[] = [
    {
      logoIcon: {
        iconName: "appleLogo",
        width: 26,
        height: 26,
      },
      buttonText: "Continue with Apple",
      buttonColor: "#000000",
      onButtonClick: () => web3authLogin("apple"),
    },
    {
      logoIcon: {
        iconName: "googleLogo",
        width: 26,
        height: 26,
      },
      buttonText: "Continue with Google",
      onButtonClick: () => web3authLogin("google"),
    },
  ];

  return isLoading ? (
    <CenterSpinnerAtom className="h-[200px]" />
  ) : (
    <div className="relative top-[-54px] flex h-screen flex-col items-center justify-between bg-[#FAFAFA] px-0 pt-[54px]">
      <div className="flex w-full flex-col items-start gap-[42px] pb-[25px]">
        <div className="flex w-full flex-col items-center gap-[20px] px-[20px] pb-[20px] pt-[50px]">
          <LogoAtom />
        </div>

        <div className="flex w-full flex-col items-start gap-[20px]">
          {!isEthBrowser && (
            <>
              <div className="flex w-full flex-col items-start gap-[10px] p-[20px]">
                {LoginButtonProps.map((props, index) => (
                  <LogInButton key={index} {...props} />
                ))}
              </div>
              <Divider
                style={{ margin: "0px", padding: "0px 20px" }}
                className="w-full px-[20px]"
              >
                OR
              </Divider>
            </>
          )}
          <div className="flex w-full flex-col items-start gap-[10px] p-[20px]">
            <LogInButton
              buttonText="Connect Wallet"
              onButtonClick={() => web3modalLogin()}
            />
          </div>
        </div>
      </div>
      <SettingCopyrightModule />
    </div>
  );
}
